import React from 'react'
import {removeZeros} from '../../../utils/misc'
import moment from 'moment'
import {getUserSettings} from '../../../storage'


class DebitA4 extends React.Component {

  render() {

    let company = this.props.company
    console.log(company);
    let debit = this.props.debit

    let settings = getUserSettings()

    let debit_date = moment(debit.date).format('D-MM-YYYY')
    let billto
    let shipping_address
    let from_address
    let optionalRow

    if(typeof debit.supplier !== "undefined" && debit.supplier !== null) {
      from_address = <div className="">
      <div className="company-address gray">
        {debit.supplier.address}
      </div>
      <div className="company-state gray">
          {debit.supplier.state} - <span className="company-pin gray">{debit.supplier.pin}</span>
      </div>
      <div className="company-email gray">
        {debit.supplier.email}
      </div>
      <div className="company-phone gray">
        {debit.supplier.phone}
      </div>
      <div className="company-state gray">
         GSTIN - {debit.supplier.gstin}
      </div>
      </div>

    }


    if(typeof company !== "undefined" && company !== null) {

      let company_gstin

      if(typeof company.gstin !== "undefined" && company.gstin !== null) {
        company_gstin = "GSTIN-"+company.gstin
      }

        shipping_address = <div>  <div className="gray">
                {company.company_name}
          </div>
          <div className="gray">
              {company.address}
          </div>
          <div className="gray">
              {company.city}
          </div>
          <div className="gray">
              {company.state}-{company.pin}
          </div></div>


      billto = <div className="row">
      <div className="col-xs-6">
        <div className="">
        <strong>Bill To</strong>
          <div className="gray">
              {company.company_name}
          </div>
          <div className="gray">
              {company.address}
          </div>
          <div className="gray">
              {company.city}
          </div>
          <div className="gray">
              {company.state}-{company.pin}
          </div>
          <div className="gray">
             {company_gstin}
          </div>
        </div>
      </div>

      <div className="col-xs-6">
        <div className="">
        <strong>Ship To</strong>
          {shipping_address}
        </div>
      </div>

      </div>

    }


    let items

    if(debit.pretnitem_set.length > 0) {
      items = debit.pretnitem_set.map((purchaseitem, index)=>{
        let discountCol, cgstcol, sgstcol, igstcol
        if(purchaseitem.discount_value > 0) {
            discountCol = <td className="text-right">{removeZeros(purchaseitem.discount_value)}</td>
        }
        else {
          discountCol = <td className="text-right"></td>
        }

        if(debit.is_igst) {
          if(purchaseitem.igst_amount > 0) {
            igstcol = <td className="text-right">
              {Number(purchaseitem.igst_amount)} ({Number(purchaseitem.gst.igst)}%)

                 </td>
          }
          else {
            igstcol = <td className="text-right"></td>
          }

        }
        else {

          if(purchaseitem.cgst_amount > 0) {
            cgstcol=  <td className="text-right">
            {Number(purchaseitem.cgst_amount)} ({Number(purchaseitem.gst.cgst)}%)
               </td>
          }
          else {
            cgstcol= <td className="text-right"></td>
          }

          if(purchaseitem.sgst_amount > 0) {
            sgstcol= <td className="text-right">
                      {Number(purchaseitem.sgst_amount)} ({Number(purchaseitem.gst.sgst)}%)
                 </td>
          }
          else {
            sgstcol = <td className="text-right"></td>
          }
        }

        let item_unit
        let unit_price = Number(purchaseitem.purchase_basic_rate),
        taxable_price = Number(purchaseitem.price),
        item_total = Number(purchaseitem.total)

        return <tr key={index}>
          <td>{purchaseitem.tableIndex}</td>
          <td><div>{purchaseitem.name}</div></td>
          <td><div>{purchaseitem.hsn}</div> </td>
          <td className="text-right">
            <div>{Number(purchaseitem.quantity)}</div>
            <div>{item_unit}</div>
            </td>
          <td className="text-right">{unit_price}</td>
          {discountCol}
          <td className="text-right">{taxable_price}</td>
            {cgstcol}{sgstcol}{igstcol}
          <td className="text-right">{item_total}</td>
      </tr>
      })
    }

    let discount
    if(debit.totalDiscount > 0) {
      discount = <div className="row">
          <div className="col-xs-6">
            <strong>Discount  </strong>
          </div>
          <div className="col-xs-6 text-right">
             &#8377; {debit.totalDiscount}
          </div>
      </div>
    }

    let totalBeforeDiscount = parseFloat(parseFloat(debit.totalPrice) + parseFloat(debit.totalDiscount)).toFixed(2)

    let cgst_header, sgst_header, igst_header
    if(debit.is_igst) {
      igst_header = <th className="text-right">IGST</th>
    }
    else {
      cgst_header = <th className="text-right">CGST</th>
      sgst_header = <th className="text-right">SGST</th>

    }

    let serial = debit.serial
    if(typeof debit.supplier_bill_no !== "undefined") {
      serial = debit.supplier_bill_no
    }
    let supplier = debit.supplier

    if(typeof settings !== "undefined" && settings !== null) {

        let declartion, bankDetails, pan
        if(settings.show_debit_pan) {
          pan = <div>Company Pan - {company.pan}</div>
        }
        if(settings.show_debit_declaration) {
          declartion = <div><u>Terms and Conditions</u>
              <div><p>{settings.debit_declaration}</p></div>
      </div>
        }

        if(settings.show_debit_bankdetails) {
          bankDetails = <div><div className="row">
              <div className="col-xs-6">Bank Name</div>
              <div className="col-xs-6">{company.bank_name}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Account No</div>
                <div className="col-xs-6">{supplier.account_no}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">IFSC</div>
                <div className="col-xs-6">{supplier.ifsc_code}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Branch </div>
                <div className="col-xs-6">{supplier.branch_name}</div>
              </div>

              </div>
        }
        optionalRow = <div className="row space-medium small" >
          <div className="col-xs-6">
            {pan}
            {declartion}
          </div>
          <div className="col-xs-6">
            {bankDetails}
          </div>
        </div>


    }


    let supplierName
    if(typeof debit.supplier !== "undefined" && debit.supplier !== null ) {
      supplierName = debit.supplier.name
    }

      return <div  className="preview-a4" >

              <div className="row">
                <div className="col-xs-6">
                  <div className="company-name text-uppercase">
                    {supplierName}
                  </div>

                  {from_address}

                </div>
                <div className="col-xs-6">
                <div className="invoice-name text-right">
                  {serial}
                </div>

                  <div className="gray text-right">
                  Date: {debit_date}
                  </div>
                </div>

              </div>

              <hr/>

              {billto}

              <div className="row space-medium">
              <div className="col-xs-12">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr className="active">
                    <th>S.No</th>
                    <th className="table-item">Item Name</th>
                    <th className="table-item">HSN</th>
                    <th className="text-right">Qty</th>
                    <th className="text-right">Unit Price</th>
                    <th className="text-right">Discount</th>
                    <th className="text-right">Taxable Price</th>
                    {cgst_header}{sgst_header}{igst_header}
                    <th className="text-right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items}
                </tbody>

              </table>
              </div>
              </div>


              <div className="row space-small">
              <div className="col-xs-6 col-xs-offset-6">

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>Amount  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {totalBeforeDiscount}
                      </div>
                  </div>

                  {discount}

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>GST  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {debit.totalTax}
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-xs-6">
                      <strong>Total  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {debit.total}
                      </div>
                  </div>

              </div>
              </div>

              {optionalRow}

              <div className="row space-small">
              <div className="col-xs-6 col-xs-offset-6">

              <div className=" text-center">
              Authorized Signature
              </div>
              </div>
              </div>


      </div>

  }
}

export default DebitA4



// WEBPACK FOOTER //
// ./src/components/debit/previews/debita4.js